export default function AppContainer ({children})
{
    return (
        <div style={{ width:"100%", minHeight:"100vh", display: "inline-flex"}}>
            {children}
        </div>
    );
}